import { OnInit, Component, Inject, Optional } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { Location } from '@angular/common';
import { SSOUtil } from '../../model/SSOUtil';
import { ActivatedRoute } from '@angular/router';
import { PershingTranslationService } from '@pershing/pershing-core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'knowledgeCentre-component',
    templateUrl: './knowledgeCentre-component.html'
})

export class KnowledgeCentreComponent implements OnInit {
    appSettings: any;
    challengeURL: string;
    timeStamp: string;
    signedValue: string;
    userRefNum: string;
    launchURL: string;
    isMacLike: boolean;
    isIOS: boolean;
    IOSMessage: boolean;
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private location: Location,
                private translationService: PershingTranslationService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private route: ActivatedRoute,
                @Optional() @Inject('AppSettings') appSettings: any,
                private sanitizer: DomSanitizer) {
                    this.appSettings = appSettings;
                    this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        // Call the wiget params service to get the valid args
        this.widgetsParamService();
        this.isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
        this.isIOS = /(iPhone|iPod|iPad)/i.test(navigator.platform);
        this.IOSMessage = SSOUtil.isIos( this.isMacLike, this.isIOS);
    }

    widgetsParamService() {
        this.nxiWidgetParamsService.getWidgetParam('/commonrest/knowledgeCentre').subscribe(
            resp => {
                if (resp.response) {
                    this.userRefNum = resp.response.rrNum;
                    const launchURL = new URL(resp.response.launchURL);
                    if(launchURL.pathname.includes('services/netxclient.rest-service/')){
                        this.launchURL = resp.response.launchURL.replace('services/netxclient.rest-service/', '') + '?SSOIndicator=NXI_SSOOUT_IDPINIT_HEWITTKC';
                    } else {
                        this.launchURL = resp.response.launchURL.replace(launchURL.pathname.split('/')[1]+'/','') + '?SSOIndicator=NXI_SSOOUT_IDPINIT_HEWITTKC';
                    }

                }
            }
        );
    }

}
